module.exports = __webpack_public_path__ + "img/step2.acc124db.png";